export default __webpack_public_path__ + "static/media/news8.2b0b2b93.jpg";